// @tennis-matches/clubmeisterschaft-core/results – upsert single result (pure)

import { __asStr } from "@tennis-matches/core/utils";

/**
 * Merge a single match result into current items map.
 * @param {object} currentItems map matchId -> result
 * @param {object} payload { matchId, setsA, setsB, gamesA?, gamesB?, status? }
 * @returns {object} new items map (unchanged if matchId empty)
 */
export function upsertMatchResult(currentItems, payload) {
  const items = currentItems && typeof currentItems === "object" ? { ...currentItems } : {};
  const matchId = __asStr(payload?.matchId);
  if (!matchId) return items;

  const next = {
    matchId,
    status: "confirmed",
    setsA: Number(payload?.setsA ?? 0),
    setsB: Number(payload?.setsB ?? 0),
    gamesA: Number(payload?.gamesA ?? 0),
    gamesB: Number(payload?.gamesB ?? 0),
    updatedAt: Date.now(),
  };

  return { ...items, [matchId]: next };
}
